import { useContext } from 'react';

import BpkInput, {
  CLEAR_BUTTON_MODES,
} from '@skyscanner-internal/backpack-web/bpk-component-input';

import Separator from '../../Separator';
import StringsContext from '../Contexts/StringsContext';
import { BOARD_TYPE } from '../server/constants';

import STYLES from './FlightSearch.module.scss';

interface FlightSearchProps {
  clearSearchValue: () => void;
  freeTextSearch: string;
  selected: string;
  updateFreeTextSearchValue: (newValue: string) => void;
}

const FlightSearch = ({
  clearSearchValue,
  freeTextSearch,
  selected,
  updateFreeTextSearchValue,
}: FlightSearchProps) => {
  const strings = useContext(StringsContext);

  return (
    <div className={STYLES.FlightSearch}>
      <div className={STYLES.FlightSearch__searchBoxContainer}>
        <BpkInput
          className={STYLES.FlightSearch__inputContainer}
          onChange={(e) => updateFreeTextSearchValue(e.target.value)}
          value={freeTextSearch}
          id="freeTextSearch"
          name="freeTextSearch"
          placeholder={
            selected === BOARD_TYPE.ARRIVALS
              ? strings.falcon_arrivals_departures_board_arrvsearchplaceholder
              : strings.falcon_arrivals_departures_board_deptsearchplaceholder
          }
          clearButtonMode={CLEAR_BUTTON_MODES.always}
          clearButtonLabel={strings.falcon_adb_clear_input}
          onClear={clearSearchValue}
          aria-label={strings.falcon_arrivals_departures_board_searchlabel}
          autoFocus
        />
      </div>

      <Separator />
    </div>
  );
};

export default FlightSearch;
